// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "*[data-v-abd4e40e] .custom-agile-carousel-styling{height:290px!important;width:100%!important}*[data-v-abd4e40e] .custom-agile-image-styling{aspect-ratio:1!important;height:290px!important;-o-object-fit:cover!important;object-fit:cover!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
